import { Link } from '@inertiajs/react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

type LeftUnreadLogoProps = {
    href?: string;
    className?: string;
    showWordmark?: boolean;
};

export function LeftUnreadLogo({
    href,
    className,
    showWordmark = true,
}: LeftUnreadLogoProps) {
    const content = (
        <div className={cn('flex items-center gap-2.5', className)}>
            <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary shadow-lg shadow-black/20">
                <Sparkles className="size-4 text-primary-foreground" />
            </div>
            {showWordmark && (
                <span className="text-sm font-semibold tracking-tight">
                    LeftUnread
                </span>
            )}
        </div>
    );

    if (href) {
        return (
            <Link href={href} className="inline-flex">
                {content}
            </Link>
        );
    }

    return content;
}
